import { Global } from "@emotion/react";
import { MantineProvider as Provider } from "@mantine/core";

import { client_selected } from "../client";
import { theme } from "../styles/theme";

interface IProps {
  children: React.ReactNode;
}

const MantineProvider = ({ children }: IProps) => {
  return (
    <Provider withGlobalStyles withNormalizeCSS theme={theme}>
      <Global
        styles={(theme) => ({
          "::-webkit-scrollbar-track-piece": {
            opacity: 0,
          },

          "::-webkit-scrollbar": {
            background: "transparent",
            opacity: 0,
            width: "15px",
            height: "10px",
          },
          "::-webkit-scrollbar-track": {
            borderRadius: "150px",
            paddingTop: "10px",
            boxShadow: "inset 0 0 5px grey",
            height: "10px",
          },
          "::-webkit-scrollbar-thumb": {
            borderRadius: "10px",
            background: client_selected.colors.primaryOpacity[2],
            border: `2px solid ${client_selected.colors.primary[0]}`,
            transition: "all 1s",
            ":hover": {
              transition: "all 1s",
              background: client_selected.colors.primary[0],
              border: `2px solid ${client_selected.colors.primaryOpacity[2]}`,
            },
          },
          "@media (max-width: 768px)": {
            "::-webkit-scrollbar": {
              height: "3px",
              width: "3px",
            },
          },

          body: {
            background: client_selected.colors.other[0],
            margin: "0",
            border: "unset",
            ":before": {
              boxSizing: "unset",
            },
          },
          label: {
            color: client_selected.colors.basic[5],
            fontWeight: "400",
            lineHeight: "155%",
            width: "100%",
            display: "flex !important",
            justifyContent: "space-between",

            span: {
              color: `${client_selected.colors.alerts[0]}  !important`,
            },
          },
        })}
      />
      {children}
    </Provider>
  );
};

export default MantineProvider;
